import { builder } from './builder';
import { units } from './constants';

export const recommendedLinksConfig = builder.holder({
  hasImage: builder.exists('recommended_links_image', {
    defaultValue: false
  }),
  useRecommendedLinks: builder.boolean('use_recommended_links', {
    defaultValue: false,
    l:'',
    d:''
  }),
  imageUrl: builder.string('recommended_links_image', {
    l:'',
    d:'',
    overrideType: 'image',
    if: 'use_recommended_links'
  }),
  title: builder.string('recommended_links_title', {
    l:'',
    d:'',
    if: 'use_recommended_links'
  }),
  text: builder.string('recommended_links_text', {
    l:'',
    d:'',
    if: 'use_recommended_links'
  }),
  noBounceUrl: builder.string('recommended_links_nobounce', {
    l:'',
    d:'',
    if: 'use_recommended_links'
  }),
  autoCloseDuration: builder.number('recommended_links_acd', {
    optional: true,
    // Warning if you change the default value, it is also set in a getParameter function in browser-sdk3/index.js
    defaultValue: 5,
    l:'',
    d:'',
    if: 'use_recommended_links',
    unit: units.seconds
  }),
  displayCloseButton: builder.boolean(
    'recommended_links_display_close_button',
    {
      // Warning if you change the default value, this parameter is forced to be true in browser-sdk3/index.js
      defaultValue: true,
      l:'',
      d:'',
      if: 'use_recommended_links'
    }
  ),
  useLoader: builder.boolean('recommended_links_use_loader', {
    l:'',
    defaultValue: false,
    d:''
  }),
  redirectUrl: builder.string('recommended_links_redirect_url', {
    l:'',
    defaultValue: '',
    d:''
  }),
  loaderTimeout: builder.number('recommended_links_loader_timeout', {
    l:'',
    defaultValue: 5,
    d:'',
    unit: units.seconds
  }),
  loaderCloseUrlRegex: builder.string(
    'recommended_links_loader_close_url_regex',
    {
      l:'',
      defaultValue: '',
      d:''
    }
  ),
  loaderImage: builder.string('recommended_links_loader_image', {
    l:'',
    defaultValue: '',
    d:''
  }),
  loaderColor: builder.string('recommended_links_loader_color', {
    l:'',
    defaultValue: '#ef3834',
    d:''
  }),
  triggerUrlRegex: builder.string('recommended_links_trigger_url_regex', {
    l:'',
    defaultValue: ''
  }),
  useFullscreen: builder.boolean('recommended_links_use_fullscreen', {
    l:'',
    defaultValue: false
  }),
  closeBtnSize: builder.number('recommended_links_close_btn_size', {
    l:'',
    defaultValue: 20,
    unit: units.pixel
  }),
  closeBtnColor: builder.string('recommended_links_close_btn_color', {
    l:'',
    defaultValue: '#575757'
  }),
  progressbarColor: builder.string('recommended_links_progressbar_color', {
    l:'',
    defaultValue: '#FFF'
  }),
  customTranslations: builder.object('recommended_links_translations', {
    defaultValue: {},
    d:''
  })
});
